import React from "react";
import { Footer } from "@imedcl/design-system";
export default function FooterContent() {
    return (
        <Footer
            country="chile"
            customClass="bg-amber-55 px-2"
            spacing="s"
            version="Versión 1.0 - 0.3" />
    );
}
